<template>
  <div>
    <!-- Page Header -->
    <div class="mb-5">
      <div class="headline saPrimary--text">
        {{ $t("screener.organizations.title") }}
      </div>
      <span class="body-1 greyDarken3--text">{{
        $t("company.companies.subtitle")
      }}</span>
    </div>

    <!-- Page Content -->
    <v-card>
      <v-card-title>
        <div v-if="total" class="title">
          <span>Total : </span>
          <b>{{ total }}</b>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          class="custom-placeholer-color"
          append-outer-icon="search"
          v-model="search"
          label="Search"
          :placeholder="'Search by title or id'"
          clear-inner-icon="rms_close"
          clearable
          single-line
          hide-details
          @keyup.enter="getCompaniesFromApi"
          @click:clear="clearSearch"
          @click:append-outer="applySearch"
          color="saSecondary"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="table_headers"
        :loading="loading"
        :items="list"
        :pagination.sync="pagination"
        :total-items="total"
        :rowsPerPageItems="rowsPerPageItems"
        item-key="id"
      >
        <template v-slot:items="props">
          <tr class="cursor-pointer" @click="viewProfile(props.item.id)">
            <td width="5%">{{ props.item.id }}</td>
            <td>
              <v-img
                width="50"
                height="50"
                v-if="props.item.logo_url"
                :src="props.item.logo_url"
              ></v-img>
            </td>
            <td class="py-1">
              <div class="body-2">
                {{ props.item.title }}
                <span v-if="props.item.is_screening_pricing_enterprise"
                  >&nbsp;•&nbsp;</span
                >
                <span
                  class="saPrimary--text"
                  v-if="props.item.is_screening_pricing_enterprise"
                  ><b>{{ $t("enterprise.title") }}</b></span
                >
              </div>
              <div v-if="props.item.owner" class="grey--text text--darken-2">
                {{ props.item.owner.email }}
              </div>
            </td>
            <td>{{ props.item.commission_percentage }}&nbsp;%</td>
            <td>{{ props.item.max_allowed_seats }}</td>
            <td>{{ props.item.members.length }}</td>
            <td>{{ props.item.total_films }}</td>
            <td>{{ props.item.screeners_count }}</td>
            <td>
              <span
                v-if="
                  props.item.addons &&
                  props.item.addons.content_management_by_team
                "
              >
                {{
                  props.item.addons.content_management_by_team.used
                }}&nbsp;/&nbsp;
                {{ props.item.addons.content_management_by_team.quantity }}
              </span>
              <span v-else> - </span>
            </td>
            <td>
              <span
                v-if="
                  props.item.addons &&
                  props.item.addons.support_management_by_team
                "
              >
                {{
                  props.item.addons.support_management_by_team.used
                }}&nbsp;/&nbsp;
                {{ props.item.addons.support_management_by_team.quantity }}
              </span>
              <span v-else> - </span>
            </td>
            <td>
              {{
                moment
                  .utc(props.item.created_at)
                  .local()
                  .format("MMM Do YYYY, HH:MM")
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import moment from "moment";

export default {
  name: "AdminCompaniesList",
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.getCompaniesFromApi();
    });
  },
  data() {
    return {
      moment,
      table_headers: [
        {
          text: "Organization ID",
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: i18n.t("screener.table.header.logo"),
          align: "left",
          sortable: false,
          value: "logo",
        },
        {
          text: i18n.t("screener.table.header.title"),
          align: "left",
          sortable: true,
          value: "title",
        },
        {
          text: "Commission (%)",
          align: "left",
          sortable: true,
          value: "commission_percentage",
        },
        {
          text: "Max. Allowed Seats",
          align: "left",
          sortable: true,
          value: "max_allowed_seats",
        },
        {
          text: i18n.t("rms.table.header.total_members"),
          align: "left",
          sortable: false,
          value: "members",
        },
        {
          text: i18n.t("rms.table.header.total_films"),
          align: "left",
          sortable: false,
          value: "total_films",
        },
        {
          text: i18n.t("screener.company.dashboard.screeners.total_screeners"),
          align: "left",
          sortable: false,
          value: "screeners_count",
        },
        {
          text: i18n.t("rms.table_header.cm_addon"),
          align: "left",
          sortable: false,
          value: "addons.content_management_by_team",
        },
        {
          text: i18n.t("rms.table_header.sm_addon"),
          align: "left",
          sortable: false,
          value: "addons.support_management_by_team",
        },
        {
          text: i18n.t("rms.table.header.created_on"),
          aligh: "left",
          sortable: true,
          value: "created_at",
        },
      ],
      search: "",
      loading: false,
      total: null,
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.adminCompany.list,
    }),
  },
  watch: {
    pagination: {
      handler: "getCompaniesFromApi",
      deep: true,
    },
  },
  methods: {
    // addOnsTotal(selected_company){
    //   let addOnsTotal= {
    //     used: 0,
    //     quantity: 0,
    //     amount: 0
    //   };
    //   if (selected_company.addons) {
    //     let addons = Object.values(selected_company.addons);
    //     addons.forEach((addOn) => {
    //       addOnsTotal.used += addOn.used;
    //       addOnsTotal.quantity += addOn.quantity;
    //       addOnsTotal.amount += addOn.amount;
    //     })
    //   }
    //   return addOnsTotal
    // },

    applySearch() {
      if (this.search.length) this.getCompaniesFromApi();
    },
    clearSearch() {
      this.search = "";
      this.getCompaniesFromApi();
    },
    async getCompaniesFromApi() {
      this.loading = true;

      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      var offset = this.getPaginationOffset(rowsPerPage, page);

      let payload = {
        offset: offset,
        limit: rowsPerPage,
        sort: sortBy,
        sorting_order: descending,
        search: this.search,
        filters: {},
      };

      try {
        let response = await this.$store.dispatch("adminCompany/list", payload);
        this.total = response.companies.total;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }

      this.loading = false;
    },
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
    viewProfile(company_id) {
      this.$router.push({
        name: "AdminCompanyProfile",
        params: {
          company_id: company_id,
        },
      });
    },
  },
};
</script>
